<div class="container-fluid mt-5 pt-5">
    <div class="row mt-4" *ngFor="let item of countdata">
        <div class="col-12 col-md-4 mb-4">
            <div class="card total-card d-flex flex-row h-100" onclick="animateCard(this)">
                <div class="card-body w-75 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-column">
                        <h5 class="card-subtitle mb-2 text-nowrap">Posted Jobs Count</h5>
                        <h6 class="card-title counter" data-target="30">{{item.PostedJobsCount}}</h6>
                    </div>
                </div>
                <div class="card-icon w-25">
                    <i class="fas fa-file-alt"></i>
                </div>
                <!--<div class="stats-badge">+5 This Week</div>-->
            </div>
        </div>

        <div class="col-12 col-md-4 mb-4">
            <div class="card shortlisted-card d-flex flex-row h-100" onclick="animateCard(this)">

                <div class="card-body w-75 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-column">
                        <h5 class="card-subtitle mb-2 text-nowrap">Applied Candidates Count</h5>
                        <h6 class="card-title counter" data-target="30">{{item.AppliedCandidatesCount}}</h6>
                    </div>
                </div><div class="card-icon w-25">
                    <i class="fas fa-user-check"></i>
                </div>
                <!--<div class="stats-badge">100% Rate</div>-->
            </div>
        </div>

        <div class="col-12 col-md-4 mb-4">
            <div class="card shortlisted-card d-flex flex-row h-100" onclick="animateCard(this)">

                <div class="card-body w-75 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-column">
                        <h5 class="card-subtitle mb-2 text-nowrap">Shortlisted Candidates Count</h5>
                        <h6 class="card-title counter" data-target="30">{{item.ShortlistedCandidatesCount}}</h6>
                    </div>
                </div><div class="card-icon w-25">
                    <i class="fas fa-user-check"></i>
                </div>
                <!--<div class="stats-badge">100% Rate</div>-->
            </div>
        </div>
    </div>
</div>
